import React from 'react';
import { useTranslation } from 'react-i18next';
import { FareProduct } from '../../services/types/apitypes';
import { IonButton } from '@ionic/react';
import CardPassItem from "./CardPassItem";

type CardPassesAddProps = {
  products: FareProduct[];
  pay: (p: FareProduct) => void;
};

export default function CardPassesAdd({ products, pay }: CardPassesAddProps) {
  const [t] = useTranslation('global');

  let body;
  if (!products || !products.length) {
    body = <strong>{t('cardpasses.noproduct')}</strong>;
  }

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">{t('cardpasses.add')}</h1>
      <p className="pt-2 pb-3 instructions ion-text-center">
        {t('cardpasses.info')}
      </p>

      {body}
      {products &&
        products.map((product: FareProduct, i: number) => {
          return <CardPassItem key={i} title={product.name} pay={() => pay(product)} price={product.price} />;
        })}
    </>
  );
}
